<script>

  let currentSize = 'sm';

  function setSmall() {
    window.document.body.parentElement.classList.remove('medium-fonts')
    window.document.body.parentElement.classList.remove('large-fonts')
    currentSize = 'sm'
  }

  function setMedium() {
    window.document.body.parentElement.classList.add('medium-fonts')
    window.document.body.parentElement.classList.remove('large-fonts')
    currentSize = 'md'
  }

  function setLarge() {
    window.document.body.parentElement.classList.add('large-fonts')
    window.document.body.parentElement.classList.remove('medium-fonts')
    currentSize = 'lg'
  }

</script>

<div>

  <div class="w-20 mx-auto flex justify-between items-baseline">
    <a class:underline="{currentSize == 'sm'}" class="decoration-2 text-[16px] leading-none" href="#" on:click={setSmall}>A</a>
    <a class:underline="{currentSize == 'md'}" class="decoration-2 text-[24px] leading-none" href="#" on:click={setMedium}>A</a>
    <a class:underline="{currentSize == 'lg'}" class="decoration-2 text-[32px] leading-none" href="#" on:click={setLarge}>A</a>
  </div>

</div>

<style lang="scss">
  :global(html.medium-fonts) {
    font-size: 1.3rem;
  }

  :global(html.large-fonts) {
    font-size: 1.5rem;
  }
</style>